import touches from './directive'
const vue2Touch = {
  install: function(Vue, options) {
    Vue.directive('touch', touches)
  }
}
export default vue2Touch



//////////////////
// WEBPACK FOOTER
// ./node_modules/vue2-touch/index.js
// module id = null
// module chunks = 